import React, { Fragment, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import IconClose from '../../assets/icons/IconClose';
import IconPlayYt from '../../assets/icons/IconPlayYt';
import { common } from '../../utils/common';

class VideoItem extends PureComponent {
   state = {
      isOpen: false,
   }

   toggleVideo = () => {
      this.setState({
         isOpen: !this.state.isOpen,
      });
   }

   preventClose = (e) => {
      e.stopPropagation();
   }

   render() {
      let embedUrl = common.createEmbedYoutubeUrl(this.props.url);
      if (embedUrl) {
         embedUrl = `${embedUrl}?autoplay=1`;
      }
      return (
         <Fragment>
            <div className="youtube-thumbnail-preview"
               onClick={this.toggleVideo}
            >
               <div
                  className="img-preview"
                  style={{ backgroundImage: `url(${common.getYoutubeThumbnailImg(this.props.url)})` }}
               />
               <div className="fake-play-btn">
                  <IconPlayYt />
               </div>
            </div>
            {
               this.state.isOpen && embedUrl &&
               ReactDOM.createPortal(
                  <div className={`presented-container preview animate__animated ${this.state.isOpen ? 'open animate__fadeIn' : ''}`}
                     tabIndex="1"
                  >
                     <button className="close-btn" onClick={this.toggleVideo}>
                        <IconClose />
                     </button>
                     <div className="presented-frame" onClick={this.toggleVideo}>
                        <div className={`video-content`}>
                           <iframe
                              src={embedUrl}
                              onClick={this.preventClose}
                              allowFullScreen
                           />
                        </div>
                     </div>
                  </div>
                  ,
                  document.querySelector('body')
               )
            }
         </Fragment>
      );
   }
}

export default VideoItem;